// extracted by mini-css-extract-plugin
export default {"content":"ProTipsDescription_content__3b+mD"};